import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'

interface FormCardState {
  editingEntities: string[]
}

const initialState: FormCardState = {
  editingEntities: [],
}

const slice = createSlice({
  name: 'formCard',
  initialState,
  reducers: {
    setEditing: (state, action: PayloadAction<string>) => {
      if (!state.editingEntities.includes(action.payload)) {
        state.editingEntities.push(action.payload)
      }
    },
    clearEditing: (state, action: PayloadAction<string>) => {
      state.editingEntities = state.editingEntities.filter(
        (k) => k !== action.payload
      )
    },
    clearAllEditing: (state) => {
      state.editingEntities = []
    },
  },
})

// Reducer
export default slice.reducer
export const { setEditing, clearEditing, clearAllEditing } = slice.actions

/**
 * Selectors
 */
const selectRawEditingEntities = (state: RootState) =>
  state[slice.name].editingEntities

export const selectIsEntityEditing = (key: string) =>
  createSelector([selectRawEditingEntities], (editingEntities) =>
    editingEntities.includes(key)
  )

export const selectHasAnyEditing = () =>
  createSelector(
    [selectRawEditingEntities],
    (editingEntities) => editingEntities.length > 0
  )

export const selectEditingEntities = () =>
  createSelector(
    [selectRawEditingEntities],
    (editingEntities) => editingEntities
  )
